import { useSettingsStore } from '~/stores/settings';

export default defineNuxtPlugin((nuxtApp) => {
  // Client tarafında çalıştığından emin oluyoruz
  if (process.client) {
    // Uygulama yüklendiğinde tema ayarlarını başlat
    nuxtApp.hook('app:mounted', () => {
      const settingsStore = useSettingsStore();
      settingsStore.initTheme();
    });
  }
});
